import { combineReducers } from 'redux';

import type { ApiError, ApiFailureAction } from 'modules/global/generic.types';
import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';
import { isFailureRequest, isStartRequest, isSuccessRequest } from 'modules/global/reducers/utils';
import type { Nullable } from 'modules/global/typing/common/common';
import {
  ASSIGN_BRANDS_TO_GUIDELINE,
  CLOSE_ASSIGN_MODAL,
  OPEN_ASSIGN_MODAL,
  PUT_GUIDELINE,
} from 'modules/guidelines/actionTypes';

// PUT is handled natively by the helpers; brand assignment is folded in as a matcher.
const EXTRA_ROOTS = [ASSIGN_BRANDS_TO_GUIDELINE];

const loadingMatchers = EXTRA_ROOTS.flatMap(root => [
  { matcher: isStartRequest(root), reducer: () => true },
  { matcher: isSuccessRequest(root), reducer: () => false },
  { matcher: isFailureRequest(root), reducer: () => false },
]);

const errorMatchers = EXTRA_ROOTS.flatMap(root => [
  { matcher: isStartRequest(root), reducer: () => null },
  { matcher: isFailureRequest(root), reducer: (_: Nullable<ApiError>, { payload }: ApiFailureAction) => payload },
]);

export default combineReducers({
  loading: loading(PUT_GUIDELINE, { matchers: loadingMatchers }),
  error: error(PUT_GUIDELINE, {
    matchers: errorMatchers,
    reducers: {
      [OPEN_ASSIGN_MODAL]: () => null,
      [CLOSE_ASSIGN_MODAL]: () => null,
    },
  }),
});
